export enum ErrorCodes {
    NotFound = 'not-found'
}
